module.exports = __webpack_public_path__ + "static/media/banner-img-1.daa11496.png";